import { useState, useEffect } from "react";
import { Box, CardContent, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { UserData, getUser } from "../getUserDB";

export default function MyCurrentPlan() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [userDB, setUserDB] = useState<UserData>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      setUserDB(data);
      setLoading(false);
    }
    dataUser();
  }, []);

  return (
    <CardContent sx={{ flexGrow: 1 }}>
      <Box sx={{ mb: 5 }}>
        <Typography gutterBottom variant={isMobile ? "h6" : "h4"} component="div">
          Meu plano
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Informações sobre seu plano atual
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent={'space-between'}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box>
              <AssignmentTurnedInIcon
                fontSize={isMobile ? "medium" : "large"}
                sx={{ color: 'text.secondary' }}
              />
            </Box>
            <Box>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Plano atual:
              </Typography>
              <Typography
                gutterBottom
                variant="h6"
                component="div"
                sx={{ marginBottom: 0 }}
              >
                {loading ? 'Verificando...' : userDB?.plano_atual ? userDB.plano_atual : 'Não identificado'}
              </Typography>
            </Box>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent={'space-between'}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box>
              <CalendarMonthIcon
                fontSize={isMobile ? "medium" : "large"}
                sx={{ color: 'text.secondary' }}
              />
            </Box>
            <Box>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Vencimento:
              </Typography>
              <Typography
                gutterBottom
                // variant={isMobile ? "body2" : "h6"}
                variant="h6"
                component="div"
                sx={{ marginBottom: 0 }}
              >
                {loading ? 'Verificando...' : userDB?.vencimento ? userDB.vencimento : 'Não identificado'}
              </Typography>
            </Box>
          </Box>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent={'space-between'}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box>
              <VerifiedUserIcon
                fontSize={isMobile ? "medium" : "large"}
                sx={{ color: 'text.secondary' }}
              />
            </Box>
            <Box>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Status:
              </Typography>
              <Typography
                gutterBottom
                variant="h6"
                component="div"
                sx={{ marginBottom: 0 }}
              >
                {loading ? 'Verificando...' : userDB?.status && userDB.status.toUpperCase()}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>
    </CardContent>
  );
}